import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { MarkerIcon } from '@rsos/assets/icons';
import { Button, Box } from '@rsos/base-components';
import { useSmartPhraseContext } from '@rsos/components/capstone/base/SmartPhrase';
import { useCurrentPSAP } from '@rsos/reduxDataStore/src/features/capstone/psapInfo';
import { useSelectedCallerID } from '@rsos/reduxDataStore/src/features/emergencyCalls';
import { getTokens, selectUser } from '@rsos/sinatra';
import { useCurrentOrgName } from '@rsos/sinatra/src/selectors';
import { type SmartPhraseContext } from '@rsos/utils/SmartPhrases';

const RequestButton = styled(Button).attrs({
  btnType: 'invisible',
  noMargin: true,
  type: 'button',
})`
  height: auto;
  padding: 4px 2px;
`;

interface RequestLocationProps {
  onClick: (locationData: SmartPhraseContext) => void;
  isOutboundSMS?: boolean;
  disabled?: boolean;
}

const RequestLocation = ({
  onClick,
  isOutboundSMS = false,
  disabled = false,
}: RequestLocationProps) => {
  const psap = useCurrentPSAP();
  const user = useSelector(selectUser);
  const token = getTokens()?.token;
  const orgName = useCurrentOrgName();
  const callerID = useSelectedCallerID() || '';

  // The location-request message can be any preconfigured message, so build the
  // full smart-phrase context — not just the location-link fields — so any
  // phrase the configured message uses can resolve.
  const smartPhraseContext = useSmartPhraseContext({
    psap,
    user,
    orgName,
    token,
    callerID,
  });

  return (
    <Box padding={isOutboundSMS ? '0' : '8px 16px 16px'}>
      <RequestButton
        onClick={() => onClick(smartPhraseContext)}
        disabled={disabled}
      >
        <MarkerIcon height={12} width={12} />
        Request Location
      </RequestButton>
    </Box>
  );
};

export default RequestLocation;
